import {v4 as uuidv4} from 'uuid';

export const generateChartId = (): string => `secure-plotly-chart-${uuidv4()}`;

export const getWindowLocationOrigin = (): string => window.location.origin;
